import SectionCard from "./common/SectionCard";
import { getLang } from "../../../store/uiStore";
import "./IndicatorsSection.css";

export default function IndicatorsSection({
    data,
    quarter,
}) {
    const lang = getLang();
    const tr = {
        section: lang === "ru" ? "Показатели деятельности" : "Нишондиҳандаҳои фаъолият",
        year: lang === "ru" ? "год" : "сол",
        accepted: lang === "ru" ? "Учитываются только принятые отчеты" : "Танҳо ҳисоботҳои қабулшуда ба назар гирифта мешаванд",
        indicator: lang === "ru" ? "Показатель" : "Нишондиҳанда",
        value: lang === "ru" ? "Значение" : "Арзиш",
    };

    if (!data) {
        return null;
    }

    const indicators = data.indicators || [];
    const republic = data.republic || [];

    const selectedQuarter = Number(quarter);

    const selectedPeriod = republic.find(
        item => item.quarter === selectedQuarter
    );

    const values = selectedPeriod?.values || {};

    const periodTitle =
        data.periods?.find(
            item => item.quarter === selectedQuarter
        )?.[lang === "ru" ? "title_ru" : "title_tj"]
        || data.periods?.find(item => item.quarter === selectedQuarter)?.title
        || "";

    return (

        <SectionCard
            title={tr.section}
            icon="bar-chart"
        >

            <div className="mb-3">

                <div className="fw-semibold">

                    {data.year} {tr.year}

                    {periodTitle
                        ? ` — ${periodTitle}`
                        : ""
                    }

                </div>

                <div className="text-muted small">

                    {tr.accepted}

                </div>

            </div>

            <div className="table-responsive">

                <table className="table table-hover align-middle mb-0">

                    <thead className="table-light">

                        <tr>

                            <th>
                                {tr.indicator}
                            </th>

                            <th
                                className="text-end"
                                style={{
                                    width: "160px",
                                }}
                            >
                                {tr.value}
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {indicators.map(indicator => {

                            const value =
                                values[indicator.id];

                            return (

                                <tr
                                    key={indicator.id}
                                >

                                    <td>

                                        {lang === "ru" ? (indicator.name_ru ?? indicator.name_tj ?? "") : (indicator.name_tj ?? indicator.name_ru ?? "")}

                                    </td>

                                    <td className="text-end fw-bold">

                                        {value === undefined
                                            ? "—"
                                            : value
                                        }

                                    </td>

                                </tr>

                            );

                        })}

                    </tbody>

                </table>

            </div>

        </SectionCard>

    );
}
